import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DataTerm from '../../atoms/list/DataTerm';
import DataDefinition from '../../atoms/list/DataDefinition';
import DefinitionList from '../DefinitionList';
import { readableNumberParts } from '../../../helpers/Numbers';
const DossierFinances = ({ dossier }) => {
    const items = [
        {
            label: dossier.is_after_verdict
                ? 'Toegewezen hoofdsom'
                : 'Hoofdsom',
            value: dossier.is_after_verdict
                ? dossier.after_verdict_specification.assigned_headsum
                : dossier.before_verdict_specification.calculated_headsum,
        },
        {
            label: 'Totaal kosten',
            value: dossier.is_after_verdict
                ? dossier.after_verdict_specification.total_costs
                : dossier.before_verdict_specification.total_costs,
        },
        {
            label: 'Totaal dossier',
            value: dossier.is_after_verdict
                ? dossier.after_verdict_specification.total_costs_dossier
                : dossier.before_verdict_specification.total_costs_dossier,
            color: 'primary',
            isTotal: true,
        },
    ];
    if (dossier.is_after_verdict) {
        items.push({
            label: 'Totaal dossier voor vonnis',
            value: dossier.before_verdict_specification.total_costs_dossier,
        });
    }
    return (_jsx(_Fragment, { children: items.map(item => {
            return (_jsxs(DefinitionList, { children: [_jsx(DataTerm, { children: item.label }), _jsx(DataDefinition, { color: item.color, isTotal: item.isTotal, children: readableNumberParts(item.value, 'EUR').long })] }, item.label));
        }) }));
};
export default DossierFinances;
